import { faCommentDots } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type React from 'react'
import styled from 'styled-components'

import type { Touchpoint } from '@/types/Touchpoints'

interface Props {
  sectionComments: Touchpoint[]
  onToggle: () => void
  isLoadingTouchpoints: boolean
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;

  &:hover {
    cursor: pointer;
  }
`

const CommentsLabel: React.FC<Props> = ({
  sectionComments,
  onToggle,
  isLoadingTouchpoints,
}) => {
  if (isLoadingTouchpoints) {
    return (
      <>
        <Container>
          <p>Loading...</p>
        </Container>
      </>
    )
  }

  return (
    <>
      <Container onClick={onToggle}>
        <p>
          {sectionComments.length} Comment
          {sectionComments.length == 1 // eslint-disable-line eqeqeq
            ? ''
            : 's'}{' '}
        </p>
        <FontAwesomeIcon
          size="1x"
          icon={faCommentDots}
          color={
            sectionComments.some(comment => comment?.author?.type === 'agent')
              ? 'red'
              : 'inherit'
          }
        />
      </Container>
    </>
  )
}

export default CommentsLabel
